import PerformanceMetricBase from './base/PerformanceMetricBase';

/**
 * @class PerformanceMetric
 * @extends PerformanceMetricBase
 */
class PerformanceMetric extends PerformanceMetricBase {

}

export default PerformanceMetric;
